import connector from 'Utils/connector';
import { setIsChromeless } from 'Webapp/shared/app/redux/actions/app';
import PathChangeMonitor from 'Webapp/shared/app/components/path-change-monitor';

export default connector({
  actions: { setIsChromeless },
})(PathChangeMonitor);
